export const AUTO_SEND_MAX_ATTEMPTS = 2
export const AUTO_SEND_RETRY_MS = 700

export type AutoSendDecision = { action: "send" } | { action: "retry_after_ms"; ms: number } | { action: "settle" } // success or final fail → clear pending

/** Decide what to do after an auto-send POST attempt (1-based). */
export function decideAutoSendAfterAttempt(args: {
  ok: boolean
  attempt: number
  maxAttempts?: number
}): AutoSendDecision {
  const maxAttempts = args.maxAttempts ?? AUTO_SEND_MAX_ATTEMPTS
  if (args.ok) return { action: "settle" }
  if (args.attempt < maxAttempts) {
    return { action: "retry_after_ms", ms: AUTO_SEND_RETRY_MS }
  }
  return { action: "settle" }
}
